<template>
    <div class="Admin_Accessor__info">
        <span class="count">
            <span class="line">|</span>
            <span class="">10분 전 접속자 수</span>
        </span> 
        <span class="accessor"> 
            {{ count }} 명
        </span>
    </div>
</template>

<script>
export default {
    // props: {
    //     count: {
    //         type: Number,
    //         required: true,
    //     },
    // },
    props: ['count']
    
}
</script>